/** Clamp gallery index after ±1 navigation (lightbox prev/next). */
export function stepGalleryIndex(current: number, length: number, delta: -1 | 1): number {
  if (length <= 0) return 0;
  const next = current + delta;
  if (next < 0) return 0;
  if (next >= length) return length - 1;
  return next;
}
